import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import MultiSelectSearchableDropdown from 'ui-library/dropdowns/MultiSelectSearchableDropdown';
import {ellipsize} from 'util/NameUtil';

import {ProcessTaskSchemaWithoutFlowchartConfigGraphQL} from '../../../../graphql-fragments/processes/schemas/__generated/ProcessTaskSchemaWithoutFlowchartConfigGraphQL';

const ELLIPSIZE_CUTOFF = 35;

export interface MultiSelectTaskSchemasDropdownProps {
  taskSchemas: Array<ProcessTaskSchemaWithoutFlowchartConfigGraphQL>;
  onSelectTaskSchemaIds: (taskSchemaIds: Array<string>) => void;
  possibleTaskSchemas: Array<ProcessTaskSchemaWithoutFlowchartConfigGraphQL>;
  disabled?: boolean;
  dataTestAttrs?: DataTestAttrs;
}

export default function MultiSelectTaskSchemasDropdown(
  props: MultiSelectTaskSchemasDropdownProps
): JSX.Element {
  const optionDatas = props.possibleTaskSchemas.map(({id, name}) => ({
    name,
    value: id,
  }));

  if (props.disabled) {
    return (
      <div className={css(styles.dropdown)}>
        {ellipsize(
          props.taskSchemas.length > 0
            ? props.taskSchemas.map(({name}) => name).join(', ')
            : 'No task schemas selected',
          ELLIPSIZE_CUTOFF
        )}
      </div>
    );
  }

  return (
    <MultiSelectSearchableDropdown
      noneSelectedMessage="Select one or more task schemas"
      optionDatas={optionDatas}
      selectedValues={props.taskSchemas.map(({id}) => id)}
      onSelect={props.onSelectTaskSchemaIds}
      dataTestAttrs={props.dataTestAttrs}
      className={css(styles.dropdown)}
    />
  );
}

const styles = StyleSheet.create({
  dropdown: {
    flex: '0.9',
    whiteSpace: 'normal',
  },
});
